import firebase_rootDB from "../../Firebase";
import axios from "axios";

export const dataUpdateInDB = async (userData) => {
  // console.log("received UserData", userData);
  const time = new Date().toISOString().slice(0, 19).replace("T", " ");
  let today_date = time.slice(0, 10);
  let temp_email = userData.email.split("@")[0];
  let current_time = new Date().toLocaleTimeString();

  firebase_rootDB
    .child(today_date)
    .child(`${current_time}`)
    .child(`${temp_email}`)
    .update(userData, (err) => {
      if (err) {
        console.log("error occured during data updation in db");
      } else {
        console.log("data updated successfully !!!");
      }
    });
};

export const emialSend = async (userData) => {
  //   console.log("userData", userData);
  let url =
    "https://us-central1-causalfunnel-21.cloudfunctions.net/CausalFunnelEmailSend";
  let headers = {
    "Content-Type": "application/json",
  };
  let data = { ...userData, topic: "Contact_Form" };
  try {
    const response = await axios.post(url, data, headers);
    console.log("response", response);
  } catch (error) {
    console.log("error occured during emailSend", error);
  }
};
